export function capitalize(word: string) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

export function getFullImageUrl(filename: string) {
  return `${process.env.VUE_APP_BASE_URL}/pages/uploads/${filename}`
}

// /pages/uploads отдаёт оригинал — до 1800px на каждую карточку, да ещё
// вторым запросом под блюр-подложку. /pages/thumbs — та же ручка превью, что
// и в кабинете (файлы у витрины и у кабинета одни и те же), просто заведённая
// и на retailer_ns: retailer_app поднимает не все неймспейсы.
// Формат задаётся расширением, бэкенд собирает превью именно в нём: если на
// webp пожалуются (оттенок, артефакты на логотипах), правится одна строка, а
// старые ссылки остаются рабочими — кеши разъезжаются сами, ключ у них URL.
const THUMB_FORMAT = 'webp'
// 800 на карточку: картинка занимает до 480 CSS-пикселей, на DPR 2 меньшее
// мылит. 200 — лента превью под фото товара (4rem), с запасом на 3x.
const THUMB_SIZE = 800

export function productThumbUrl(filename: string, size: number = THUMB_SIZE,
                                format: string = THUMB_FORMAT) {
  return `${process.env.VUE_APP_BASE_URL}/pages/thumbs/${size}/${filename}.${format}`
}